import React from 'react';
import { Globe2 } from 'lucide-react';
import { PrimaryButton } from 'src/shared/components/button/Button';

type OnboardStepProps = {
    customerName: string;
    currentCustomerId: string;
    onCreateOrganisation: () => Promise<void>;
    isCreating: boolean;
    error: string | null;
};

const OnboardStep = ({ customerName, currentCustomerId, onCreateOrganisation, isCreating, error }: OnboardStepProps) => {
    return (
        <div className='flex flex-col items-center gap-6'>
            <div className='flex items-center justify-center w-20 h-20 rounded-full bg-grey-20'>
                <Globe2 className='w-10 h-10 text-primary' />
            </div>
            <div className='flex flex-col items-center gap-2 max-w-md text-center'>
                <h2 className='text-2xl font-semibold text-primary'>No Global Nature Risk</h2>
                <p className='text-base text-grey-70'>
                    The organisation &ldquo;{customerName}&rdquo; ({currentCustomerId}) has not been onboarded into Global Nature Risk.
                </p>
            </div>
            <PrimaryButton onClick={onCreateOrganisation} disabled={isCreating} data-testid='create-organisation-button'>
                {isCreating ? 'Onboarding...' : 'Onboard Organisation'}
            </PrimaryButton>
            {error && (
                <p className='text-sm text-red-100' data-testid='create-error-message'>
                    {error}
                </p>
            )}
        </div>
    );
};

export default OnboardStep;
